import { axiosInstance as axios } from 'Api'
import { handlingResponse, encodeQueryString } from 'Utility/globalMethods'
/* eslint-disable global-require */
if (process.env.ISMOCK) {
  require('Mocks/user/user')
}

export async function callGetTerminalIdList({ urlParams, headers }) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.MERCHANT_PROFILE_API}api/v1/merchants/${urlParams.tenantId}/${
        urlParams.merchantId
      }/terminals${urlParams?.queryObj ? encodeQueryString(urlParams.queryObj) : ''}`,
      headers
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callUserProfile(headers, params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.MERCHANT_PROFILE_API}api/v1/users/profile${encodeQueryString(params)}`,
      headers: {
        'cache-control': 'no-cache',
        ...headers
      },
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getSubscriptionGlobal(params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.MERCHANT_PROFILE_API}api/v1/features/${params.tenantId}/${params.merchantId}/subscriptions`,
      withCredentials: true,
      headers: {
        tenantId: params.tenantId,
        merchantId: params.merchantId,
        roles: params.roles
      },
      data: JSON.stringify(params.body)
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function postSubscriptionGlobal(params) {
  let data
  try {
    data = await axios({
      method: 'post',
      url: `${process.env.MERCHANT_PROFILE_API}api/v1/features/${params.urlParams.tenantId}/${params.urlParams.merchantId}/${params.urlParams.terminalId}/subscriptions/${params.urlParams.subscriptionId}`,
      headers: { ...params.urlParams },
      data: JSON.stringify(params.body)
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

// @generator api:method
